var LDStem = (() => {
  var a = Object.defineProperty;
  var $ = Object.getOwnPropertyDescriptor;
  var m = Object.getOwnPropertyNames;
  var p = Object.prototype.hasOwnProperty;
  var v = (i, e) => {
      for (var n in e) a(i, n, { get: e[n], enumerable: !0 });
    },
    z = (i, e, n, t) => {
      if ((e && typeof e == "object") || typeof e == "function")
        for (let o of m(e))
          !p.call(i, o) &&
            o !== n &&
            a(i, o, {
              get: () => e[o],
              enumerable: !(t = $(e, o)) || t.enumerable,
            });
      return i;
    };
  var w = (i) => z(a({}, "__esModule", { value: !0 }), i);
  var P = {};
  v(P, { stem: () => M });
  var b = {
      ational: "ate",
      tional: "tion",
      enci: "ence",
      anci: "ance",
      izer: "ize",
      bli: "ble",
      alli: "al",
      entli: "ent",
      eli: "e",
      ousli: "ous",
      ization: "ize",
      ation: "ate",
      ator: "ate",
      alism: "al",
      iveness: "ive",
      fulness: "ful",
      ousness: "ous",
      aliti: "al",
      iviti: "ive",
      biliti: "ble",
      logi: "log",
    },
    E = {
      icate: "ic",
      ative: "",
      alize: "al",
      iciti: "ic",
      ical: "ic",
      ful: "",
      ness: "",
    },
    y = "[^aeiou]",
    r = "[aeiouy]",
    s = "(" + y + "[^aeiouy]*)",
    c = "(" + r + "[aeiou]*)",
    f = new RegExp("^" + s + "?" + c + s),
    I = new RegExp("^" + s + "?" + c + s + c + "?$"),
    l = new RegExp("^" + s + "?(" + c + s + "){2,}"),
    u = new RegExp("^" + s + "?" + r),
    x = new RegExp("^" + s + r + "[^aeiouwxy]$"),
    L = /ll$/,
    R = /^(.+?)e$/,
    S = /^(.+?)y$/,
    d = /^(.+?(s|t))(ion)$/,
    C = /^(.+?)(ed|ing)$/,
    O = /(at|bl|iz)$/,
    h = /^(.+?)eed$/,
    Y = /^.+?[^s]s$/,
    k = /^.+?(ss|i)es$/,
    A = /([^aeiouylsz])\1$/,
    q =
      /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/,
    B = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/,
    D =
      /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  function g(i) {
    let e = String(i).toLowerCase();
    if (e.length < 3) return e;
    let n = !1;
    e.codePointAt(0) === 121 && ((n = !0), (e = "Y" + e.slice(1))),
      k.test(e) ? (e = e.slice(0, -2)) : Y.test(e) && (e = e.slice(0, -1));
    let t;
    return (
      (t = h.exec(e))
        ? f.test(t[1]) && (e = e.slice(0, -1))
        : (t = C.exec(e)) &&
          u.test(t[1]) &&
          ((e = t[1]),
          O.test(e)
            ? (e += "e")
            : A.test(e)
            ? (e = e.slice(0, -1))
            : x.test(e) && (e += "e")),
      (t = S.exec(e)) && u.test(t[1]) && (e = t[1] + "i"),
      (t = q.exec(e)) && f.test(t[1]) && (e = t[1] + b[t[2]]),
      (t = B.exec(e)) && f.test(t[1]) && (e = t[1] + E[t[2]]),
      (t = D.exec(e))
        ? l.test(t[1]) && (e = t[1])
        : (t = d.exec(e)) && l.test(t[1]) && (e = t[1]),
      (t = R.exec(e)) &&
        (l.test(t[1]) || (I.test(t[1]) && !x.test(t[1]))) &&
        (e = t[1]),
      L.test(e) && l.test(e) && (e = e.slice(0, -1)),
      n && (e = "y" + e.slice(1)),
      e
    );
  }
  function M(i) {
    return g(String(i || ""));
  }
  return w(P);
})();
